import { render, staticRenderFns } from "./sorelationdetail.vue?vue&type=template&id=8c0f24b8&scoped=true&"
import script from "./sorelationdetail.vue?vue&type=script&lang=js&"
export * from "./sorelationdetail.vue?vue&type=script&lang=js&"
import style0 from "./sorelationdetail.vue?vue&type=style&index=0&id=8c0f24b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0f24b8",
  null
  
)

export default component.exports